import React, { useState, useEffect,useContext } from "react";
import { ObjectLiteral } from "../../interfacesProps/ObjectLiteralProps";
import { Avatar, Link } from "@material-ui/core";
import { Spacing, FontSize, Colors } from "../../theme/Theme";
import { StarRatings } from "../../components/StarRatings";
import {
  getMonthAndYearComparedToNow,
  formatWorkerType,
  getMonthAndYearByMonth,
} from "../../util/FormattingService";
import { RBButton, RBButtonType } from "../../components/RBButton";
import { ApprovalModeEnum, NotAvailableString, roleNameEnum, RoutePathConstant } from "../../util/Common";
import { ColumnStyle } from "../../theme/ComponentTheme";
import {
  RenderTextWithTitle,
  renderTextWithTitleForSkills,
  renderTextWithTitleAndChildComponent,
  detailTextStyle,
} from "../../components/TextWithHeader";
import { RBCardView } from "../../components/RBCardView";
import { RBAlert, RBErrorAlert } from "../../components/RBAlert";
import { AlertInfoProps } from "../../interfacesProps/AlertInfoProps";
import { workerTypeEnum } from "../../util/Enumeration";
import { ShiftService } from "../../api/ShiftService";
import { ApplicantState } from "../../interfacesProps/SetApplicantStateByPharmacyProps";
import axios from 'axios';
import { Document, Page } from 'react-pdf';
import {
  useHistory,
  RouteComponentProps,
  withRouter,
  useLocation,
} from "react-router";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { ErrorMessageProps } from "../../interfacesProps/ErrorMessageProps";
import { ShiftProps } from "../../interfacesProps/ShiftProps";
import { RBContext } from "../../components/RBContext";
import moment from 'moment';
import { IndustryModeEnum } from "../../api/constants";
import { AuthService } from "../../api/AuthService";
import RBPlacementFeeModal from "../../components/RBPlacementFeeModal";
import { RBModal, RBProofModal } from "../../components/RBModal";
import { RBEmptyBlock } from "../../components/RBEmptyBlock";
import PDFViewer from "../../components/PdfViewer";
import { WorkerStats } from "../../components/WorkerStats";
import { Typography, FormControlLabel, Checkbox } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { showOnHoldAlert } from "../../util/showOnHoldAlert";
import { isWorkerRBPayVerified, isRBPayAvailableForLocation } from "../../util/rbPay";
import { RBPayrollVerifiedBadge } from "../searchShift/RBPayrollVerifiedBadge";
import { rbPayrollOwnerService } from "../rbPayrollOwnerSettings/services/rbPayrollOwner.service";
import { RBPayrollStatus } from "../rbPayrollOwnerSettings/types/rbPayrollOwner.types";
import { AccountInfoContext } from "../../components/AccountInfoContext";


  interface LocationApplicantsPageWithoutRouterProps extends RouteComponentProps<any> {
    applicants?: any;
    pharmacy?:any;
  }

const LocationApplicantsPageWithoutRouter: React.FC<LocationApplicantsPageWithoutRouterProps> = ({
  match,...props
}) => {
const {applicants, pharmacy} = props;
console.log("applicants123",props.applicants)
  const [reloadPage, setReloadPage] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [extendeds, setExtendeds] = useState<Set<string>>(new Set());
  const [isAlertShowing, setAlertShowing] = useState(false);
  const [alertInfo, setAlertInfo] = useState<AlertInfoProps>({});
  const [submitErrorMessage, setSubmitErrorMessage] = useState<
    ErrorMessageProps
  >();
  const { industryMode,primaryColor,secondaryColor,contactEmail } = useContext(RBContext);
  const [account, setAccount] = useState<any>([]);
  const [resumeModal, setReumeModal] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState<any>(null); // Store the selected applicant
  const [numPages, setNumPages] = useState<any>(null);
  const [currentPharmacy, setCurrentPharmacy] = useState<any>(null);
  const [roleName, _] = useState<string>(AuthService.getRoleName());
  // True only when this owner's location has NOT started RB Pay setup — drives the
  // "Setup RB Pay" CTA under the verified badge. Fetched once at screen level.
  const [locationRBPayNotSetup, setLocationRBPayNotSetup] = useState(false);

  const history = useHistory();


   const [proofsModalOpen, setProofsModalOpen] = useState(false);
  const [proofList, setProofList] = useState<any[]>([]);
  const [proofViewerOpen, setProofViewerOpen] = useState(false);
  const [selectedProof, setSelectedProof] = useState<any>(null);

//Update account information when it changes in the context
  const { accountInformation } = useContext(AccountInfoContext);
  useEffect(() => {
    setAccount(accountInformation);
  }, [accountInformation]);


  useEffect(() => {
    const fetchData = async () => {
      try {

        if (!accountInformation) return;

        localStorage.removeItem("downloadedPdf")
        setIsPageLoading(true);

        // Owner-only: does THIS location still need RB Pay setup? Drives the
        // contextual "Setup RB Pay" CTA. 404 (no profile) → NOT_STARTED inside the
        // service. Non-owners can't manage RB Pay, so we skip the lookup. Also gate
        // on the location's admin availability flag (pharmacy.isRbPayAvailable):
        // when RB Pay isn't enabled for this location there is no setup to offer.
        if (accountInformation?.owner && pharmacy?.id && isRBPayAvailableForLocation(pharmacy)) {
          try {
            const status = await rbPayrollOwnerService.getRBPayrollStatus({
              account: accountInformation,
              location: pharmacy,
            });
            setLocationRBPayNotSetup(status === RBPayrollStatus.NOT_STARTED);
          } catch (statusErr) {
            console.log("RB Pay location status error", statusErr);
          }
        }

      } catch (err) {
        setSubmitErrorMessage((err as any).response ? (err as any).response.data : (err as any).message);
        console.log("LocationApplicantsPageWithoutRouter error", err);
      } finally {
        setIsPageLoading(false);
      }
    };

    fetchData();
  }, [reloadPage, accountInformation]);



  const fetchAndStorePdfData = async (applicant:any) => {
    console.log(" ",applicant)
    const resumeUrl = applicant?.resume;
    
    axios.get(resumeUrl, { responseType: 'arraybuffer' })
      .then(response => {
        const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
        const pdfData = URL.createObjectURL(pdfBlob);
        
        setSelectedApplicant((prevApplicants:any) => {
              return {
                ...prevApplicants,
                pdfDataUrl: pdfData,
              }
        });
      })
      .catch(() => {
        console.log('Error fetching PDF data.');
      });
  };


  const setAlertState = (newState:any) => {
    setAlertShowing(newState.isAlertShowing);
    setAlertInfo(newState.alertInfo);
  };
    // fetch proofs and open list modal (shows N/A alert if none)
    const openProofsForApplicant = (applicant: any) => {
      try {
        const docs = (applicant.documents || []).map((d: any) => ({
          id: d.id,
          name: d.documentName || "Document",
          fileUrl: d.documentFile,
          updatedAt: d.updatedAt,
        }));
  
        if (!docs.length) {
          setAlertInfo({
            title: "Proof of Credentials",
            message: "N/A — no proof of credentials available for this worker.",
            buttons: [
              <RBButton key="ok" onClick={() => setAlertShowing(false)} text="OK" buttonBackgroundColor={primaryColor} />
            ],
          });
          setAlertShowing(true);
          return;
        }
  
        setProofList(docs);
        setProofsModalOpen(true);
      } catch (err) {
        setSubmitErrorMessage((err as any)?.response ? (err as any).response.data : (err as any).message);
      }
    }
  
    const openProofViewer = async (proof:any) => {
      try {
        const url = proof?.fileUrl;
        if (!url) return;
  
        // detect pdf by path (handles querystring)
        const isPdf = /\.pdf(\?|$)/i.test(url);
  
        if (isPdf) {
          // fetch PDF as arraybuffer and create blob URL to avoid react-pdf CORS issues
          const resp = await axios.get(url, { responseType: "arraybuffer" });
          const pdfBlob = new Blob([resp.data], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(pdfBlob);
          setSelectedProof({ ...proof, fileUrl: blobUrl, isPdf: true, _objectUrl: blobUrl });
        } else {
          // image or other file - use original url
          setSelectedProof({ ...proof, fileUrl: url, isPdf: false });
        }
        setNumPages(null);
        setProofViewerOpen(true);
      } catch (err) {
        console.error("openProofViewer error", err);
        setSubmitErrorMessage((err as any)?.response ? (err as any).response.data : (err as any).message);
      }
    };
     const closeProofViewer = () => {
      // revoke object URL if we created one
      if (selectedProof && (selectedProof as any)._objectUrl) {
        try {
          URL.revokeObjectURL((selectedProof as any)._objectUrl);
        } catch (e) { /* ignore */ }
      }
      setProofViewerOpen(false);
      setSelectedProof(null);
      setNumPages(null);
    };
    const closeProofsModal = () => { setProofsModalOpen(false); setProofList([]); };
  
     // lightweight renderer to reuse the same structure as renderResume
    const renderProofs = (applicant: any) => {
      const hasProof = (applicant?.documents || []).length > 0;
      return (
        <>
          {hasProof
            ? renderTextWithTitleAndChildComponent(
                "Proof(s) of Credentials",
                <Link
                  onClick={() => openProofsForApplicant(applicant)}
                  style={{ ...detailTextStyle, color: Colors.themeBlue, cursor: 'pointer' }}
                >
                  {"View"}
                </Link>
              )
            : RenderTextWithTitle("Proof(s) of Credentials", NotAvailableString)}
        </>
      );
    };



  const setExtendedsForPharmacist = (pharmacistId: string) => {
    if (
      pharmacy?.approval?.approvalMode === ApprovalModeEnum.OnHold
    ) {
      showOnHoldAlert({
        setAlertState,
        primaryColor,
        contactEmail,
      });
      return;
    }
    //const { extendeds } = this.state;
    if (extendeds.has(pharmacistId)) {
      extendeds.delete(pharmacistId);
      //Since react will identify state changes only if the state property was replaced, and not mutated (shallow compare), you'll have to create a new Set from the old one, and apply the changes to it.

      setExtendeds(new Set(extendeds));
    } else {
      extendeds.add(pharmacistId);
      setExtendeds(new Set(extendeds));
    }
  };

  const renderSkills = (worker: ObjectLiteral) => {
    const skills = worker.skills || [];
    const skillSets = account?.networks?.[0]?.skillSet?.workerSkillSets || [];

    return (
      <>
      <div
          style={{
            height: 1,
            backgroundColor: 'lightgray',
            marginTop:10,
            marginBottom:10
          }}
        />
        {skillSets.length > 0 &&
          skillSets.map((skillType: any) => {
            const matchedSkills = skills
              .filter((skill: any) => skill.type === skillType)
              .map((skill: any) => skill.name);

            const capitalizedTitle =
              skillType.charAt(0).toUpperCase() +
              skillType.slice(1) +
              (skillType === 'specialization' ? 's' : '');

            return (
              <div style={ColumnStyle}>
                {renderTextWithTitleForSkills(capitalizedTitle, matchedSkills)}
              </div>
            );
          })}
      </>
    );
  };

 
  const renderName = (applicant: ObjectLiteral) => {
    const { pharmacist } = applicant;
    const name = `${pharmacist.firstName} ${pharmacist.lastName}`;
    const rating = applicant.rating.averageRating ?? 0;
    const numberRatings = applicant.rating.numberRatings ?? 0;
    const workerType = formatWorkerType(pharmacist.type);
    return (
      <>
      <div
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            flex: 1,
          }}
        >
          <div
            style={{
              fontSize: FontSize.largest,

              fontWeight: "bold",
              flexWrap: "wrap",
            }}
          >
            {name}
          </div>

          <StarRatings rating={rating} numberReviews={numberRatings} page="shiftDetails"/>
        </div>
      </div>
      {/* <div style={ColumnStyle}>
          
         
          {shiftData?.pharmacy?.networkPaid && shiftData.allowOffers ?
            <>
            {RenderTextWithTitle("", "")}
            </>:
            <>
            {RenderTextWithTitle("", "")}
            {RenderTextWithTitle("", "")}

            </>
          }
     </div> */}
     
     </>
    );
  };


  const renderStudent = (applicant: ObjectLiteral) => {
    const { pharmacist } = applicant;
    const showExtended = extendeds.has(applicant.id);

    return (
      <>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Type", formatWorkerType(pharmacist.type))}
          {RenderTextWithTitle("Registration #", pharmacist.licenseNumber)}
          {RenderTextWithTitle(
            "Assist Experience",
            getMonthAndYearByMonth(pharmacist.pharmacyAssistantExperienceMonths)
          )}
        </div>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Academic Year", pharmacist.currentSchoolYear)}
          {RenderTextWithTitle("Institution", pharmacist.graduationInstitution)}
          {RenderTextWithTitle("", "")}
        </div>
          <div style={ColumnStyle}>
         {renderResume(pharmacist)}
         {renderProofs(applicant)}
         {RenderTextWithTitle( "", "")}
         </div>


        <div
          style={{
            height: 1,
            backgroundColor: 'lightgray',
            marginTop:10,
            marginBottom:10
          }}
        />
        <WorkerStats account={pharmacist} page="viewApplicant" />

        {showExtended && applicant.pharmacist.about &&(
          <>
            <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
            <div style={{ fontSize: FontSize.largest, fontWeight: "bold" }}>
              About Me
            </div>
            <div style={{ marginTop: Spacing.small, marginBottom: Spacing.medium }}>
            {applicant.pharmacist.about || 'N/A'}
            </div>
          </>
        )}
        {/* {showExtended && applicant.pharmacist.acceptedEmploymentTypes && (
          <>
          <hr style={{ border: 'none', borderTop: `1px solid ${Colors.mediumGrey}`, margin: `${Spacing.small} 0` }} />
          <div style={{ marginTop: Spacing.medium }}>
            <Typography style={{ fontWeight: 'bold' }}>Payment Methods</Typography>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
              {(applicant.pharmacist.acceptedEmploymentTypes || []).map((method: string) => (
                <FormControlLabel
                  key={method}
                  control={
                    <Checkbox
                      checked={true}
                      icon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                      checkedIcon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                    />
                  }
                  label={method}
                />
              ))}
            </div>
          </div>

          </>
        )} */}
        <>{showExtended && renderSkills(pharmacist)}</>
      </>
    );
  };
  const renderAssistant = (applicant: ObjectLiteral) => {
    const { pharmacist } = applicant;
    const yearGraduated = pharmacist.graduationYear;
    const showExtended = extendeds.has(applicant.id);

    return (
      <>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Type", formatWorkerType(pharmacist.type))}
          {RenderTextWithTitle(
            "Assist Course",
            pharmacist.pharmacyAssistantCourseCompleted ? "Yes" : "No"
          )}
          {RenderTextWithTitle(
            "Assist Experience",
            getMonthAndYearByMonth(pharmacist.pharmacyAssistantExperienceMonths)
          )}
        </div>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Graduate In", yearGraduated)}
          {RenderTextWithTitle(
            "Graduate From",
            pharmacist.graduationInstitution
          )}
           {RenderTextWithTitle( "", "")}
          
        </div>
         <div style={ColumnStyle}>
           {renderResume(pharmacist)}
            {renderProofs(applicant)}
            {RenderTextWithTitle( "", "")}
         </div>
        <div
          style={{
            height: 1,
            backgroundColor: 'lightgray',
            marginTop:10,
            marginBottom:10
          }}
        />
        <WorkerStats account={pharmacist} page="viewApplicant" />

        {showExtended && applicant.pharmacist.about &&(
          <>
            <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
            <div style={{ fontSize: FontSize.largest, fontWeight: "bold" }}>
              About Me
            </div>
            <div style={{ marginTop: Spacing.small, marginBottom: Spacing.medium }}>
            {applicant.pharmacist.about || 'N/A'}
            </div>
          </>
        )}

        {/* {showExtended && applicant.pharmacist.acceptedEmploymentTypes && (
          <>
          <hr style={{ border: 'none', borderTop: `1px solid ${Colors.mediumGrey}`, margin: `${Spacing.small} 0` }} />
          <div style={{ marginTop: Spacing.medium }}>
            <Typography style={{ fontWeight: 'bold' }}>Payment Methods</Typography>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
              {(applicant.pharmacist.acceptedEmploymentTypes || []).map((method: string) => (
                <FormControlLabel
                  key={method}
                  control={
                    <Checkbox
                      checked={true}
                      icon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                      checkedIcon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                    />
                  }
                  label={method}
                />
              ))}
            </div>
          </div>

          </>
        )} */}
        <>{showExtended && renderSkills(pharmacist)}</>
      </>
    );
  };
  const renderPharmacistAndTechnician = (applicant: ObjectLiteral) => {
    console.log("renderPharmacistAndTechnician ", applicant);
    const { pharmacist } = applicant;
    const yearGraduated = pharmacist.graduationYear;
    const licensedDate = pharmacist.licensedDate
      ? getMonthAndYearComparedToNow(pharmacist.licensedDate)
      : NotAvailableString;
    const showExtended = extendeds.has(applicant.id);

    return (
      <>
        <div style={ColumnStyle}>
        {RenderTextWithTitle("Type", formatWorkerType(pharmacist.type))}
          {RenderTextWithTitle("License Number", pharmacist.licenseNumber)}
          {RenderTextWithTitle("Years Licensed", licensedDate)}
        </div>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Licensed In", pharmacist.licenseProvince)}

          {RenderTextWithTitle(
            "Distance",
            Math.round(applicant.distance / 1000) + "km (Est.)"
          )}
         {RenderTextWithTitle(
            "Graduate From",
            pharmacist.graduationInstitution
          )}
          
        </div>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Graduate In", yearGraduated)}
           {renderResume(pharmacist)}
          
          {renderProofs(applicant)}
          
        </div>
        <div
          style={{
            height: 1,
            backgroundColor: 'lightgray',
            marginTop:10,
            marginBottom:10
          }}
        />
        <WorkerStats account={pharmacist} page="viewApplicant" />

        {showExtended && applicant.pharmacist.about &&(
          <>
            <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
            <div style={{ fontSize: FontSize.largest, fontWeight: "bold" }}>
              About Me
            </div>
            <div style={{ marginTop: Spacing.small, marginBottom: Spacing.medium }}>
            {applicant.pharmacist.about || 'N/A'}
            </div>
          </>
        )}

        {/* {showExtended && applicant.pharmacist.acceptedEmploymentTypes && (
          <>
          <hr style={{ border: 'none', borderTop: `1px solid ${Colors.mediumGrey}`, margin: `${Spacing.small} 0` }} />
          <div style={{ marginTop: Spacing.medium }}>
            <Typography style={{ fontWeight: 'bold' }}>Payment Methods</Typography>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
              {(applicant.pharmacist.acceptedEmploymentTypes || []).map((method: string) => (
                <FormControlLabel
                  key={method}
                  control={
                    <Checkbox
                      checked={true}
                      icon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                      checkedIcon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                    />
                  }
                  label={method}
                />
              ))}
            </div>
          </div>

          </>
        )} */}
        <>{showExtended && renderSkills(pharmacist)}</>
      </>
    );
  };

  const renderLicensedDentistWorker = (applicant: ObjectLiteral) => {
    const { pharmacist } = applicant;
    const showExtended = extendeds.has(applicant.id);

    const licenseExpiryDate = pharmacist.licenseExpiryDate
      ? moment(pharmacist.licenseExpiryDate).format('YYYY - MM')
      : 'N/A';
    const licensedDate = pharmacist.licensedDate
      ? getMonthAndYearComparedToNow(pharmacist.licensedDate)
      : 'N/A';


    return (
      <>
        <div style={ColumnStyle}>
          {RenderTextWithTitle('Type', formatWorkerType(pharmacist.type))}
          {RenderTextWithTitle("Registration #", pharmacist.licenseNumber)}
          {RenderTextWithTitle("Years Licensed", licensedDate)}
          
        </div>
        <div style={ColumnStyle}>
        {RenderTextWithTitle("Registered In", pharmacist.licenseProvince)}
          {RenderTextWithTitle("Expires On", licenseExpiryDate)}

          {RenderTextWithTitle(
            "City",
            pharmacist.address.city
          )}
          
        </div>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Graduated From", pharmacist.graduationInstitution,)}
          {RenderTextWithTitle(
            "Graduated In",
            pharmacist.graduationYear,
          )}
         {RenderTextWithTitle( "", "", )}
        </div>
        
         <div style={ColumnStyle}>
         {renderResume(pharmacist)}
         {renderProofs(applicant)}
          {RenderTextWithTitle( "", "", )}
         </div>

        <div
          style={{
            height: 1,
            backgroundColor: 'lightgray',
            marginTop:10,
            marginBottom:10
          }}
        />
        <WorkerStats account={pharmacist} page="viewApplicant" />

        {showExtended && applicant.pharmacist.about &&(
          <>
            <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
            <div style={{ fontSize: FontSize.largest, fontWeight: "bold" }}>
              About Me
            </div>
            <div style={{ marginTop: Spacing.small, marginBottom: Spacing.medium }}>
            {applicant.pharmacist.about || 'N/A'}
            </div>
          </>
        )}

        {/* {showExtended && applicant.pharmacist.acceptedEmploymentTypes && (
          <>
          <hr style={{ border: 'none', borderTop: `1px solid ${Colors.mediumGrey}`, margin: `${Spacing.small} 0` }} />
          <div style={{ marginTop: Spacing.medium }}>
            <Typography style={{ fontWeight: 'bold' }}>Payment Methods</Typography>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
              {(applicant.pharmacist.acceptedEmploymentTypes || []).map((method: string) => (
                <FormControlLabel
                  key={method}
                  control={
                    <Checkbox
                      checked={true}
                      icon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                      checkedIcon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                    />
                  }
                  label={method}
                />
              ))}
            </div>
          </div>

          </>
        )} */}
        {showExtended && 
          <>
          {renderSkills(pharmacist)}</>
        }
      </>
    );
  };

  const renderNonLicensedDentistWorker = (applicant: ObjectLiteral) => {
    const { pharmacist } = applicant;
    const showExtended = extendeds.has(applicant.id);


    return (
      <>
     
        <div style={ColumnStyle}>
        {RenderTextWithTitle('Type', formatWorkerType(pharmacist.type))}
          {RenderTextWithTitle("Graduated From", pharmacist.graduationInstitution,)}
          {RenderTextWithTitle(
            "Graduated In",
            pharmacist.graduationYear,
          )}
         
          
        </div>
        <div style={ColumnStyle}>
        {RenderTextWithTitle(
            "Experience",
            getMonthAndYearByMonth(
              pharmacist.pharmacyAssistantExperienceMonths,
            ),
          )}
          {RenderTextWithTitle(
            "City",
            pharmacist.address.city
          )}
            {RenderTextWithTitle( "", "", )}
        </div>

         <div style={ColumnStyle}>
         {renderResume(pharmacist)}
         {renderProofs(applicant)}
          {RenderTextWithTitle( "", "", )}
         </div>


        <div
          style={{
            height: 1,
            backgroundColor: 'lightgray',
            marginTop:10,
            marginBottom:10
          }}
        />
        <WorkerStats account={pharmacist} page="viewApplicant" />

        {showExtended && applicant.pharmacist.about &&(
          <>
            <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
            <div style={{ fontSize: FontSize.largest, fontWeight: "bold" }}>
              About Me
            </div>
            <div style={{ marginTop: Spacing.small, marginBottom: Spacing.medium }}>
            {applicant.pharmacist.about || 'N/A'}
            </div>
          </>
        )}
        {/* {showExtended && applicant.pharmacist.acceptedEmploymentTypes && (
          <>
          <hr style={{ border: 'none', borderTop: `1px solid ${Colors.mediumGrey}`, margin: `${Spacing.small} 0` }} />
          <div style={{ marginTop: Spacing.medium }}>
            <Typography style={{ fontWeight: 'bold' }}>Payment Methods</Typography>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
              {(applicant.pharmacist.acceptedEmploymentTypes || []).map((method: string) => (
                <FormControlLabel
                  key={method}
                  control={
                    <Checkbox
                      checked={true}
                      icon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                      checkedIcon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                    />
                  }
                  label={method}
                />
              ))}
            </div>
          </div>

          </>
        )} */}
        {showExtended && 
        <>
        {renderSkills(pharmacist)}</>
        }
      </>
    );
  };

  const openResumeModal = (applicant: any) => {
    console.log("open",applicant)
    setSelectedApplicant(applicant);
    fetchAndStorePdfData(applicant); // Fetch and store PDF data when the modal is opened
    setReumeModal(true);
  };

  

  const renderResume = (worker: ObjectLiteral) => {
    console.log("renderResume ", worker.resume);
    return (
      <>
        {worker.resume
          ? renderTextWithTitleAndChildComponent(
              "Resume",
              <Link
                onClick={() => openResumeModal(worker)}
                style={{ ...detailTextStyle, color: Colors.themeBlue, cursor: 'pointer' }}
              >
                {"View"}
              </Link>
            )
          : RenderTextWithTitle("Resume", NotAvailableString)}
      </>
    );
  };

  const renderAlerts = () => {
    return (
      <RBAlert
        show={isAlertShowing}
        alertTitle={alertInfo?.title}
        alertMessage={alertInfo?.message}
        buttons={alertInfo?.buttons}
      />
    );
  };
 
  const goToRBPaySetup = () => {
    history.push(RoutePathConstant.RBPayrollOwnerSetup, {
      selectedLoc: pharmacy,
    });
  };

  const renderApplicant = (applicant: ObjectLiteral) => {
    const { pharmacist } = applicant;
    console.log("renderApplicant ", selectedApplicant);
    const showExtended = extendeds.has(applicant.id);
    let associationLogo = null;
    const userAssociationMember = applicant.userAssociationMember || [];
    const rbVerified = (applicant.pharmacist?.approval && applicant.pharmacist?.approval?.rbVerified) ? applicant.pharmacist?.approval?.rbVerified : false;
    if (userAssociationMember.length > 0) {
      associationLogo = userAssociationMember[0].association.logo;
    }
    const requestLength = applicant.userToRequests.length;

    return (
      <>
      {selectedApplicant && <RBModal
          open={resumeModal}
          onClose={onResumeClose}
          modalTitle={"Resume"
          }
          header={
            <RBEmptyBlock
              style={{
                width: "100%",
                height: Spacing.large,
                backgroundColor: Colors.defaultGrey,
                flexShrink: 0,
              }}
            />
          }
          children={
              renderRequestedRateContent(selectedApplicant)
          }
        />}
      
     
      <div
        style={{
          display: "flex",
          width: "100%",
          paddingLeft: Spacing.large,
          paddingRight: Spacing.large,
          paddingTop: Spacing.large,
          paddingBottom: Spacing.large,
          flexDirection: "row",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {/* Avatar and association logo */}
          <div>
            <Avatar
              style={{ height: 124, width: 124 }}
              // src={pharmacist.profilePhoto}
              src={pharmacist.profilePhoto}
            >
              :(
            </Avatar>
            {associationLogo && (
              <>
              <img
                src={associationLogo}
                alt={"associationLogo"}
                style={{
                  width: 96,
                  height: 36,
                  marginTop: 4,
                  marginBottom: 4,
                }}
              />
              <br></br>
              </>
            )}
            {
              (rbVerified === false
                && applicant.networks[0].id === "7b89c1df-df98-41e8-a06c-f3d1d748de84"
                && pharmacy?.networkId === "7b89c1df-df98-41e8-a06c-f3d1d748de84") ? null :
              <img
                src={
                  pharmacy?.networkId === applicant?.networks[0].id ?
                    require('../../img/50x50-01.png')
                    : require('../../img/100x100-02-01.png')
                }
                alt={"networkIcon"}
                style={{
                  // width: 70,
                  height: 50,
                  marginLeft: 37
                }}
              />
            }
            {/* RB Pay Verified badge + Setup CTA — kept inside the avatar block so
                they hug the profile picture/logos instead of floating in the
                column's vertical center (the column is space-between). */}
            {isWorkerRBPayVerified(applicant) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: Spacing.small,
                  marginTop: Spacing.small,
                }}
              >
                <RBPayrollVerifiedBadge />
                {locationRBPayNotSetup && account?.owner && (
                  <RBButton
                    // Non-breaking space before "RB" so the button's flex layout
                    // doesn't trim the gap when renderRBPayText splits on "RB Pay".
                    text={"Setup RB Pay"}
                    onClick={goToRBPaySetup}
                    buttonBackgroundColor={primaryColor}
                    style={{ width: "100%" }}
                  />
                )}
              </div>
            )}
            </div>
          <RBButton
            buttonBackgroundColor={primaryColor}
            onClick={() => setExtendedsForPharmacist(applicant.id)}
            text={`View ${showExtended ? "less" : "more"}`}
          />
          
        </div>
        {/* Applicant Detail */}
        <div style={{ flex: 1, marginLeft: Spacing.larger, filter: pharmacy?.approval?.approvalMode === ApprovalModeEnum.OnHold ? 'blur(4px)': 'none' }}>
          {renderName(applicant)}
          {(pharmacist.type === workerTypeEnum.pharmacistStudent ||
            pharmacist.type === workerTypeEnum.technicianStudent) &&
            renderStudent(applicant)}
          {pharmacist.type === workerTypeEnum.assistant &&
            renderAssistant(applicant)}
          {(pharmacist.type === workerTypeEnum.pharmacist ||
            pharmacist.type === workerTypeEnum.technician) &&
            renderPharmacistAndTechnician(applicant)}

          {(pharmacist.type === workerTypeEnum.dentist ||
              pharmacist.type === workerTypeEnum.dentistRDA ||
              pharmacist.type === workerTypeEnum.dentistCDA ||
              pharmacist.type === workerTypeEnum.dentistLDA ||
              pharmacist.type === workerTypeEnum.dentistCDA2 ||
              pharmacist.type === workerTypeEnum.dentistRDT ||
              pharmacist.type === workerTypeEnum.dentistRDH ||
              pharmacist.type === workerTypeEnum.dentistLDH ||
              pharmacist.type === workerTypeEnum.denturist) &&
              renderLicensedDentistWorker(applicant)}
            {(pharmacist.type === workerTypeEnum.dentistAdministrator ||
              pharmacist.type === workerTypeEnum.dentistSterilizationAssistant ||
              pharmacist.type === workerTypeEnum.dentistDT ||
              pharmacist.type === workerTypeEnum.dentistChairSideAssistant ||
              pharmacist.type === workerTypeEnum.dentistDA1 ||
              pharmacist.type === workerTypeEnum.dentistDA2 ||
              pharmacist.type === workerTypeEnum.dentistDA12 ||
              pharmacist.type === workerTypeEnum.LabourMechanical ||
              pharmacist.type === workerTypeEnum.LabourElectrical ||
              pharmacist.type === workerTypeEnum.LabourPlumber) &&
              renderNonLicensedDentistWorker(applicant)}
          
          <div style={{ alignItems: "flex-end",display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",}}>
                <RBButton
                  text={requestLength > 1 ? `View ${requestLength} Shifts Applied` : `View ${requestLength} Shift Applied`}
                  onClick={() =>{
                    if (
                      pharmacy?.approval?.approvalMode === ApprovalModeEnum.OnHold
                    ) {
                      showOnHoldAlert({
                        setAlertState,
                        primaryColor,
                        contactEmail,
                      });
                      return;
                    }
                    history.push(`${RoutePathConstant.ApplicantsShift}`, {
                    account: account,
                    userId: applicant.id,
                    pharmacist:applicant.pharmacist,
                    pharmacy:pharmacy
                  })}}
                  //isLoading={isLoading}
                  buttonBackgroundColor={secondaryColor}
                  style={{marginTop:40}}
                />
              </div>
        </div>
      </div>
      </>
    );
  };
  const onResumeClose= () => {
    setReumeModal(false)
    setSelectedApplicant(null);
   };
   const renderRequestedRateContent =  (applicant:any) => {
    console.log("selectedApplicant",applicant)
    return (
      <div
        style={{
          backgroundColor: Colors.defaultGrey,
          display: "flex",
          flex: 1,
          userSelect:"none",
          pointerEvents:"none"

        }}
      >
        
          <RBCardView
            style={{
              flex: 1,
              marginLeft: Spacing.large,
              marginRight: Spacing.large,
              marginBottom: Spacing.smallest,
              paddingLeft: Spacing.large,
              paddingTop: Spacing.large,
              paddingRight: Spacing.large,
              paddingBottom: Spacing.large,
            }}
          >
              <Document  file={applicant.pdfDataUrl}
               onLoadSuccess={({ numPages })=>setNumPages(numPages)}
              onLoadError={(error) => console.error('PDF Load Error:', error)}>
                 {Array.apply(null, Array(numPages))
                .map((x, i)=>i+1)
                .map(page => <Page pageNumber={page}/>)}
              </Document>
          </RBCardView>
       
      </div>
    );
  };
  if(isPageLoading)
  {
    return <LoadingIndicator/>
  }

  return (
    <>
     
      {renderAlerts()}
      <RBErrorAlert
        show={submitErrorMessage ? true : false}
        errorMessage={JSON.stringify(submitErrorMessage, null, 2)}
        onClose={() => {
          setSubmitErrorMessage(undefined);
        }}
      />

      <RBProofModal
              open={proofsModalOpen}
              onClose={closeProofsModal}
              modalTitle={"Proof of Credentials"}
              header={<RBEmptyBlock style={{ width: "100%", height: Spacing.large, backgroundColor: Colors.defaultGrey }} />}
              children={
                <div style={{ display: "inline-block", width: 640, maxWidth: "90vw", verticalAlign: "top" }}>
                <RBCardView style={{ padding: Spacing.large }}>
                  {proofList.map((p) => (
                    <div key={p.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: Spacing.small }}>
                      <div>
                        <div style={{ fontWeight: 600 }}>{p.name}</div>
                        {/* <div style={{ color: Colors.darkGrey }}>{p.updatedAt ? moment(p.updatedAt).format('YYYY-MM-DD hh:mm A') : ""}</div> */}
                      </div>
                      <RBButton text="View" onClick={() => openProofViewer(p)} buttonBackgroundColor={secondaryColor} />
                    </div>
                  ))}
                </RBCardView>
                <div style={{ display: "flex", justifyContent: "center", padding: Spacing.medium }}>
              <RBButton
                text="Close"
                onClick={closeProofsModal}
                buttonBackgroundColor={primaryColor}
                style={{ minWidth: 160 }}
              />
            </div>
          </div>
      
              }
            />
      
      
            <RBModal
              open={proofViewerOpen}
              onClose={closeProofViewer}
              modalTitle={selectedProof?.name || "Document"}
              header={<RBEmptyBlock style={{ width: "100%", height: Spacing.large, backgroundColor: Colors.defaultGrey }} />}
              children={
                <RBCardView style={{ padding: Spacing.large }}>
                  {selectedProof?.fileUrl && selectedProof?.isPdf ? (
                    <>
                      <Document
                        file={selectedProof.fileUrl}
                        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                        onLoadError={(error) => {
                          console.error("PDF Load Error:", error);
                          setSubmitErrorMessage({ message: "Unable to load PDF" } as any);
                        }}
                      >
                        {Array.from(new Array(numPages), (_el, index) => (
                          <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                        ))}
                      </Document>
                    </>
                  ) : selectedProof?.fileUrl ? (
                    <div style={{ textAlign: "center" }}>
                      <img src={selectedProof.fileUrl} alt={selectedProof.name} style={{ maxWidth: "100%", maxHeight: "80vh" }} />
                    </div>
                  ) : null}
                </RBCardView>
              }
              />
      {/* {isPageLoading ? (
        <LoadingIndicator />
      ) : ( */}
      <div style={{ marginTop: Spacing.large, marginBottom: Spacing.large }}>
         {applicants.length === 0 && (
          <RBCardView
            marginHorizontal={Spacing.medium}
            style={{
              padding: Spacing.large,
              marginTop: Spacing.medium,
            }}
          >
           No applicants yet, try back later!
          </RBCardView>
        )}
      </div>

        <div style={{ marginTop: Spacing.large, marginBottom: Spacing.large }}>
          {applicants.map((applicant:any) => (
            <div
              key={applicant.id}
              children={
                <RBCardView
                  marginHorizontal={Spacing.large}
                  style={{ marginBottom: Spacing.large }}
                  children={renderApplicant(applicant)}
                />
              }
            />
          ))}
        </div>
      {/* )} */}
    </>
  );
};

export const LocationApplicantsPage = withRouter(LocationApplicantsPageWithoutRouter);
